import '@firebase/functions-compat';
//# sourceMappingURL=index.esm.js.map
